import { Component, AfterContentInit, Output, EventEmitter, OnInit, AfterContentChecked } from '@angular/core';
import {
	Subscription, DataLoaderService, CommonDataService,
	PriceCalculationService, SummaryService
} from '../expert-service-call.index';

import { ExpertSummaryValidationComponent } from '../expert-summary-validation/expert-summary-validation.component'
import { SummaryValidationComponent } from '../../normal-screen-components/summary-validations/summary-validations.component';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';

@Component({
	selector: 'expert-selected-options',
	templateUrl: './expert-selected-options.template.html',
	styleUrls: ['./expert-selected-options.component.css']
})
export class ExpertSelectedOptionsComponent {
	public imageURL: String;
	public imageName: String;
	private selectedColor;
	private selectedAdditionalColor;
	private selectedTrim;
	private selectedRim;
	private selectedUpholstery;
	public vehicleInfo: any;
	private hideToolTip = false;
    private tempImageName: string; 
	public classNames = ["MB+ACLASS", "MB+BCLASS", "MB+CCLASS", "MB+ECLASS", "MB+GCLASS", "MB+SCLASS", "MB+MCLASS"];

	public selectedExpertOptionsDictionary = {
		'selectedFactory': [],
		'selectedLocal': [], 'selectedPackage': [], 'selectedLocalPackage': [], 'standardOptions': []
	}
	public editIconDictionary = {
		'showColorEditIcon': true, 'showAddColorEditIcon': true, 'showRimEditIcon': true, 'showTrimEditIcon': true, 'showFactoryEditIcon': true,
		'showLocalEditIcon': true, 'showPackageEditIcon': true, 'showUpholsteryEditIcon': true
	}
	public expandOptionDictionary = {
		'expandExpertFactoryOptions': false, 'expandExpertStandardOptions': false, 'expandExpertLocalOptions': false, 'expandExpertPackageOptions': false
	}

	public arrow = "right";
	public icon = "gray";

	public subscription: Subscription;
	public currency: string;
	public vehicleDetails: any; vehClass: string; tempVehClass: string;
	constructor(private dataLoaderService: DataLoaderService,private vehicleInfoService: VehicleInfoService, private priceService: PriceCalculationService,
		private summaryService: SummaryService, private commonDataService: CommonDataService, private expertSummaryValidationComponent: ExpertSummaryValidationComponent,
		private summaryValidationComponent: SummaryValidationComponent) {

			this.vehicleInfo = this.vehicleInfoService.extractData();
		if (this.dataLoaderService.vehicleInfo.vehicleClass === "MB+GLCLASS+") {
			this.vehClass = this.dataLoaderService.vehicleInfo.vehicleClass.split('+')[1];
			this.tempVehClass = this.vehClass.substring(0, 2) + '-' + this.vehClass.substring(2, 7);
		}
		else if (this.dataLoaderService.vehicleInfo.vehicleClass === "SMART") {
			this.tempVehClass = this.dataLoaderService.vehicleInfo.vehicleClass;
		}
		else {
			let count = 0;
			for (let i in this.classNames) {
				if (this.dataLoaderService.vehicleInfo.vehicleClass == this.classNames[i]) {
					this.vehClass = this.dataLoaderService.vehicleInfo.vehicleClass.split('+')[1];
					this.tempVehClass = this.vehClass[0] + '-' + this.vehClass.substring(1, 6);
					count++;
				}
			}
			if (count == 0) {
				this.tempVehClass = undefined;
			}

		}
		this.vehicleDetails = this.dataLoaderService.data.vehInfo;
		// this.priceService.priceDictionary.globalPrice = this.dataLoaderService.data.vehInfo[0].priceBpmBm;
		this.currency = this.dataLoaderService.data.currencyType;
	}
	showEdit(id) {
		if (id == 'colorEdit') {
			this.editIconDictionary.showColorEditIcon = false;
		}
		else if (id == 'addColorEdit') {
			this.editIconDictionary.showAddColorEditIcon = false;
		}
		else if (id == 'upholsteryEdit') {
			this.editIconDictionary.showUpholsteryEditIcon = false;
		}
		else if (id == 'trimEdit') {
			this.editIconDictionary.showTrimEditIcon = false;
		}
		else if (id == 'rimEdit') {
			this.editIconDictionary.showRimEditIcon = false;
		}
		else if (id == 'factoryEdit') {
			this.editIconDictionary.showFactoryEditIcon = false;
		}
		else if (id == 'localEdit') {
			this.editIconDictionary.showLocalEditIcon = false;
		}
		else if (id == 'PackageEdit') {
			this.editIconDictionary.showPackageEditIcon = false;
		}
	}
	hideEdit(id) {
		if (id == 'colorEdit') {
			this.editIconDictionary.showColorEditIcon = true;
		}
		else if (id == 'addColorEdit') {
			this.editIconDictionary.showAddColorEditIcon = true;
		}
		else if (id == 'upholsteryEdit') {
			this.editIconDictionary.showUpholsteryEditIcon = true;
		}
		else if (id == 'trimEdit') {
			this.editIconDictionary.showTrimEditIcon = true;
		}
		else if (id == 'rimEdit') {
			this.editIconDictionary.showRimEditIcon = true;
		}
		else if (id == 'factoryEdit') {
			this.editIconDictionary.showFactoryEditIcon = true;
		}
		else if (id == 'localEdit') {
			this.editIconDictionary.showLocalEditIcon = true;
		}
		else if (id == 'PackageEdit') {
			this.editIconDictionary.showPackageEditIcon = true;
		}
	}
	ngOnInit() {

		if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {

			if( Utils.isCountryCA_N(this.vehicleInfo.orderingMarket)  || Utils.isCountryCA_T(this.vehicleInfo.orderingMarket)){
		
				//default color options
				this.dataLoaderService.data.color.forEach(element =>{
					if(element.selected === true){
						this.selectedColor = element;
					}
				});
				this.priceService.notifyNormalCompItem({ fromComponent: "expertColor", data: [this.selectedColor] });
				
				//default additinoal color
				if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT'){
					this.dataLoaderService.data.additionalColor.forEach(element => {
						if (element.selected === true) {
							this.selectedAdditionalColor = element;
						}
					});
					this.priceService.notifyNormalCompItem({fromComponent: "expertAddColor", data: [this.selectedAdditionalColor]});
				}

				//default upholstery options
				this.dataLoaderService.data.upholstery.forEach(element => {
					if(element.selected === true){
						this.selectedUpholstery = element;
					}
				});
				this.priceService.notifyNormalCompItem({ fromComponent: "expertUpholstery", data: [this.selectedUpholstery] });
			}

			//default standard options
			this.dataLoaderService.data.stdOpt.forEach(element => {
				if (element.selected === true) {
					this.selectedExpertOptionsDictionary.standardOptions.unshift(element);
				}
			});
			//this.cdr.detectChanges();
			this.priceService.notifyNormalCompItem({ fromComponent: "expertStandard", data: this.selectedExpertOptionsDictionary.selectedFactory });
			//default rim options
			this.dataLoaderService.data.rim.forEach(element => {
				if (element.selected === true) {
					this.selectedRim = element;
				}
			});

			this.priceService.notifyNormalCompItem({ fromComponent: "expertRim", data: this.selectedRim });

			//default trim options
			this.dataLoaderService.data.trim.forEach(element => {
				if (element.selected === true) {
					this.selectedTrim = element;
				}
			});

			this.priceService.notifyNormalCompItem({ fromComponent: "expertTrim", data: this.selectedTrim });

			// default factory options
			this.dataLoaderService.data.facOptions.forEach(element => {
				if (element.selected === true) {
					this.selectedExpertOptionsDictionary.selectedFactory.push(element);
				}
			});
			this.priceService.notifyNormalCompItem({ fromComponent: "expertFactory", data: [this.selectedExpertOptionsDictionary.selectedFactory] });
			// default local options
			this.dataLoaderService.data.options.forEach(element => {
				if (element.selected === true) {
					this.selectedExpertOptionsDictionary.selectedLocal.push(element);
				}
			});
			this.priceService.notifyNormalCompItem({ fromComponent: "expertLocal", data: [this.selectedExpertOptionsDictionary.selectedLocal] });
			// default package options
			this.dataLoaderService.data.packages.forEach(element => {
				if (element.selected === true) {
					this.selectedExpertOptionsDictionary.selectedPackage.push(element);
				}
			});
			this.priceService.notifyNormalCompItem({ fromComponent: "expertPackage", data: [this.selectedExpertOptionsDictionary.selectedPackage] });

			// default local package options
			this.dataLoaderService.data.localPackagesList.forEach(element => {
				if (element.selected === true) {
					this.selectedExpertOptionsDictionary.selectedLocalPackage.push(element);
				}
			});
			this.priceService.notifyNormalCompItem({ fromComponent: "expertLocal", data: [this.selectedExpertOptionsDictionary.selectedLocalPackage] });

			// this.priceService.expertModePriceCalculation();
			this.priceService.normalModePriceCalculation();
		}

	}

	ngAfterContentInit() {

		this.getSelectedOptions();
		if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {

			this.getAmendData();
		}
	}

	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}

	getAmendData() {

		//standard options
		for (let i in this.dataLoaderService.data.stdOpt) {
			if (this.dataLoaderService.data.stdOpt[i].selected === true) {
				this.selectedExpertOptionsDictionary.standardOptions.unshift(this.dataLoaderService.data.stdOpt[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedExpertOptionsDictionary.standardOptions] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.selectedExpertOptionsDictionary.standardOptions] });

		// color
		for (let i in this.dataLoaderService.data.color) {
			if (this.dataLoaderService.data.color[i].selected === true) {
				this.selectedColor = this.dataLoaderService.data.color[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.selectedColor] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.selectedColor] });

		//Additional color
		for (let i in this.dataLoaderService.data.additionalColor) {
			if (this.dataLoaderService.data.additionalColor[i].selected === true) {
				this.selectedAdditionalColor = this.dataLoaderService.data.additionalColor[i];
			}
		}

		this.priceService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.selectedAdditionalColor] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.selectedAdditionalColor] });

		//Trim
		for (let i in this.dataLoaderService.data.trim) {
			if (this.dataLoaderService.data.trim[i].selected === true) {
				this.selectedTrim = this.dataLoaderService.data.trim[i];
			}
		}
		if (this.selectedTrim != undefined) {
			this.priceService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.selectedTrim] });
			this.priceService.notifyExpertCompItem({ fromComponent: "expertTrim", data: [this.selectedTrim] });
		}

		//rim
		for (let i in this.dataLoaderService.data.rim) {
			if (this.dataLoaderService.data.rim[i].selected === true) {
				this.selectedRim = this.dataLoaderService.data.rim[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.selectedRim] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.selectedRim] });

		//Upholstery
		for (let i in this.dataLoaderService.data.upholstery) {
			if (this.dataLoaderService.data.upholstery[i].selected === true) {
				this.selectedUpholstery = this.dataLoaderService.data.upholstery[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.selectedUpholstery] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.selectedUpholstery] });

		//Factory Options
		for (let i in this.dataLoaderService.data.facOptions) {
			if (this.dataLoaderService.data.facOptions[i].selected === true) {
				this.selectedExpertOptionsDictionary.selectedFactory.unshift(this.dataLoaderService.data.facOptions[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.selectedExpertOptionsDictionary.selectedFactory] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.selectedExpertOptionsDictionary.selectedFactory] });

		//Local Options
		for (let i in this.dataLoaderService.data.options) {
			if (this.dataLoaderService.data.options[i].selected === true) {
				this.selectedExpertOptionsDictionary.selectedLocal.unshift(this.dataLoaderService.data.options[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.selectedExpertOptionsDictionary.selectedLocal] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.selectedExpertOptionsDictionary.selectedLocal] });

		//Package options
		for (let i in this.dataLoaderService.data.packages) {
			if (this.dataLoaderService.data.packages[i].selected === true) {
				this.selectedExpertOptionsDictionary.selectedPackage.unshift(this.dataLoaderService.data.packages[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedExpertOptionsDictionary.selectedPackage] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.selectedExpertOptionsDictionary.selectedPackage] });

		//Local Package Options
		for (let i in this.dataLoaderService.data.localPackagesList) {
			if (this.dataLoaderService.data.localPackagesList[i].selected === true) {
				this.selectedExpertOptionsDictionary.selectedLocalPackage.unshift(this.dataLoaderService.data.localPackagesList[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedExpertOptionsDictionary.selectedLocalPackage] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.selectedExpertOptionsDictionary.selectedLocalPackage] });

		// Price calculation
		this.priceService.normalModePriceCalculation();

		//For traffic lights
		// this.pr.progressBarValidation();
	}


	getSelectedOptions() {
		this.subscription = this.commonDataService.getSelectedClass().subscribe(selectedOption => {
			this.imageURL = selectedOption;
		});
		this.subscription = this.commonDataService.getSelectedClassName().subscribe(selectedOption => {
			this.imageName = selectedOption;
			// changes for tooltip
			if (this.imageName.length <= 40){
				this.hideToolTip = true;
				document.getElementById('desc-holder').style.height = '82px';
			  } else {
				this.tempImageName = this.imageName.substring(0, 37) + "...";
				this.hideToolTip = false;
			  }
		});

		this.subscription = this.priceService.notifyObservableExpertComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertColor") {
				this.selectedColor = selectedOption.data;
			} else if (selectedOption.fromComponent == "expertAddColor") {
				if (selectedOption.data[0] !== undefined)
					this.selectedAdditionalColor = selectedOption.data;
			} else if (selectedOption.fromComponent == "expertUpholstery") {
				this.selectedUpholstery = selectedOption.data;
			} else if (selectedOption.fromComponent == "expertTrim") {
				if (selectedOption.data[0] != undefined) {
					this.selectedTrim = selectedOption.data[0];
				} else {
					if (selectedOption.data != undefined) {
						if (selectedOption.data != undefined) {
							let temp = [];
							temp.push(selectedOption.data);
							if (temp[0].length == 0) {
								this.selectedTrim = undefined;
							} else {
								this.selectedTrim = selectedOption.data;
							}
						}
					}
				}
			} else if (selectedOption.fromComponent == "expertRim") {
				if (selectedOption.data[0] != undefined) {
					this.selectedRim = selectedOption.data[0];
				} else {
					if (selectedOption.data != undefined) {
						this.selectedRim = selectedOption.data;
					}
				}
			} else if (selectedOption.fromComponent == "expertFactory") {
				this.selectedExpertOptionsDictionary.selectedFactory = (selectedOption.data[0]);
			} else if (selectedOption.fromComponent == "expertLocal") {
				this.selectedExpertOptionsDictionary.selectedLocal = (selectedOption.data[0]);
			} else if (selectedOption.fromComponent == "expertPackage") {
				this.selectedExpertOptionsDictionary.selectedPackage = (selectedOption.data[0]);
			} else if (selectedOption.fromComponent == "expertLocalPackage") {
				this.selectedExpertOptionsDictionary.selectedLocalPackage = (selectedOption.data[0]);
			} else if (selectedOption.fromComponent == "expertStandard") {
				this.selectedExpertOptionsDictionary.standardOptions = (selectedOption.data[0]);
			}

			// this.priceService.expertModePriceCalculation();
			this.priceService.normalModePriceCalculation();
		});

	}

	expandExpertFactoryOptionsFunc() {
		this.expandOptionDictionary.expandExpertFactoryOptions = !this.expandOptionDictionary.expandExpertFactoryOptions;
	}
	expandExpertStandardOptionsFunc() {
		this.expandOptionDictionary.expandExpertStandardOptions = !this.expandOptionDictionary.expandExpertStandardOptions;
	}
	expandExpertLocalOptionsFunc() {
		this.expandOptionDictionary.expandExpertLocalOptions = !this.expandOptionDictionary.expandExpertLocalOptions;
	}
	expandExpertPackageOptionsFunc() {
		this.expandOptionDictionary.expandExpertPackageOptions = !this.expandOptionDictionary.expandExpertPackageOptions;
	}
	/**
	 * For closing the summary page on click of Cancel Button
	 * @param none
	 * @returns none
	 */
	closeSummary() {
		this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
	}
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
	backToComponent() {
		this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
		this.dataLoaderService.flagDictionary.expertFlag = false;
	}
	openSuccessMesssage() {
		if (this.dataLoaderService.vehicleInfo.urlFlag == '0' || this.dataLoaderService.vehicleInfo.urlFlag == '1') {
			this.submitData();
			this.dataLoaderService.flagDictionary.expertSuccessFlag = true;
		}
		if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag == '3') {

			if (!this.dataLoaderService.flagDictionary.expertvalidated) {
				this.expertSummaryValidationComponent.alternateOptionsForURLFlag2();
			}
			else {
				this.submitData();
			}
		}
	}
	
	validateConfiguration() {
		// this.dataLoaderService.flagDictionary.loadingFlag = true;
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT'  && this.dataLoaderService.data.additionalColor.length > 0) {
			if ( (this.selectedColor.length === 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length === 0) || 
			(this.selectedColor === undefined && this.selectedUpholstery === undefined && this.selectedAdditionalColor === undefined) || 
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length !== 0) ||
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length !== 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length !== 0)) {
				this.dataLoaderService.flagDictionary.expertSuccessFlag = false;
			}
			else {
				this.openSuccessMesssage();
				this.dataLoaderService.flagDictionary.expertSuccessFlag = true;
			}
		}
		else {
			if ((!this.selectedColor && !this.selectedUpholstery) || 
			(this.selectedColor == undefined && this.selectedUpholstery == undefined) || 
			(this.selectedColor !==[]  && this.selectedUpholstery == undefined) ||
			(this.selectedUpholstery!==[]  && this.selectedColor == undefined) ||
			(this.selectedColor.length == 0 && this.selectedUpholstery.length == 0) || 
			(this.selectedUpholstery.length == 0 && this.selectedColor.length !== 0 ) ||  
			(this.selectedColor.length == 0 && this.selectedUpholstery.length !== 0 )) {
				this.dataLoaderService.flagDictionary.expertSuccessFlag = false;


			}
			else {

				this.openSuccessMesssage();
				this.dataLoaderService.flagDictionary.expertSuccessFlag = true;
			}
		}
	}
	submitData() {
		let expertConfigData = this.summaryService.submitData();
		(<HTMLInputElement>document.getElementById('acceptString')).value = expertConfigData + '';
		(<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
		(<HTMLFormElement>document.getElementById('form1')).submit();
	}
	/**
	 * For printing the summary page
	 * @param none
	 * @returns none
	 */
	printSummary() {
		this.summaryService.printSelectedData();
	}
	/**
	 * To export the summary to Excel
	 * @param none
	 * @returns none
	 */
	exportToExcel() {
		this.summaryService.exportSelectedDataToExcel();
	}

}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-selected-options/expert-selected-options.component.ts